module.exports = __webpack_public_path__ + "static/media/pic1.0d9c7130.JPG";